import { render, staticRenderFns } from "./RoundButtonImage.vue?vue&type=template&id=2ebcd31b&"
import script from "./RoundButtonImage.vue?vue&type=script&lang=js&"
export * from "./RoundButtonImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VAvatar,VBtn,VIcon,VImg,VSpeedDial})
